import {Component, Inject, forwardRef} from '@angular/core';
import {AppComponent} from './app.component';
import { MediaMatcher } from '@angular/cdk/layout';
import { isDefined } from '@angular/compiler/src/util';
import {Roles} from "./guards/roles";
import { StorageService } from './services/system/storage.service';
import { TreeNode } from 'primeng/components/common/treenode';
import { Router } from '@angular/router';

@Component({
    selector: 'app-sidebar',
    templateUrl: './app.sidebar.component.html'
})

export class AppSideBarComponent {
    mobileQuery: MediaQueryList;
    largeScreenQuery: MediaQueryList;
    selectedLinkIndex:number=-1;
    tiles: TreeNode[];
    constructor(
	    public app: AppComponent,
	    media: MediaMatcher,
	    private router: Router,
	    public storageService: StorageService,) {
        this.mobileQuery = media.matchMedia('(max-width: 600px)');
        this.largeScreenQuery = media.matchMedia('(max-width:1024px)');
    }
	
    selectedLinkChange(index:number){
        this.selectedLinkIndex = index;
        if(this.largeScreenQuery.matches){        
            this.app.sidebarActive = false;
        }
	}
}



// WEBPACK FOOTER //
// ./src/app/app.sidebar.component.ts